import { ImageUpload } from "melodies-source/ImageUpload";
import styled from "styled-components";

export const ImageUploader = styled(ImageUpload)`
  input[type="file"] + div > div {
    margin: 0 !important;
  }
`;
